export default __webpack_public_path__ + "media/images/Masto-D1-Poisson-Avril-4021edbdaa89012584fe83f3958ec3fd.png";